<template>
    <div class="modals">
        <div class="modals-inner">
            <h2 class="modals-inner-title">პროდუქტის დამატება</h2>
            <button class="modals-inner-closer" @click="emit('close')">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.121"
                    height="12.121"
                    viewBox="0 0 12.121 12.121"
                >
                    <g
                        id="close-circle"
                        transform="translate(-244.109 -260.109)"
                    >
                        <path
                            id="Vector"
                            d="M0,10,10,0"
                            transform="translate(245.17 261.17)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-2"
                            data-name="Vector"
                            d="M10,10,0,0"
                            transform="translate(245.17 261.17)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                    </g>
                </svg>
            </button>

            <div class="modals-content">
                <div class="item-info">
                    <div class="icon">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.17004 7.43994L12 12.5499L20.77 7.46991"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M12 21.6099V12.5399"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M17 13.24V9.58002L7.51001 4.09998"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                        </svg>
                    </div>
                    <div class="name">
                        <span>თრექინგი</span>
                        <p>{{ parcel.tracking_number }}</p>
                    </div>
                </div>

                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <form
                        method="post"
                        @submit.prevent="handleSubmit(onSave)"
                        @keyup.enter="handleSubmit(onSave)"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            rules="required"
                            tag="div"
                        >
                            <div
                                :class="{
                                    'select-input': true,
                                    'is-invalid': errors[0] ? true : false,
                                }"
                            >
                                <select
                                    v-model="type"
                                    :class="`parcelTypes-${props.parcel.id}`"
                                >
                                    <option></option>
                                    <option
                                        v-for="(
                                            item, index
                                        ) in props.parcelTypes"
                                        :key="index"
                                        :value="item.id"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                            <span
                                v-if="errors[0]"
                                class="invalid-feedback"
                                role="alert"
                            >
                                <strong>{{ errors[0] }}</strong>
                            </span>
                        </ValidationProvider>

                        <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|float"
                            tag="div"
                        >
                            <div
                                :class="{
                                    'calculator-inpout': true,
                                    'is-invalid': errors[0] ? true : false,
                                }"
                            >
                                <input
                                    class="w-100"
                                    autocomplete="off"
                                    type="text"
                                    :placeholder="
                                        props.country === 2 ||
                                        props.country === 4
                                            ? 'ფასი TL'
                                            : 'ფასი ' + props.currency.currency
                                    "
                                    v-model="price"
                                />
                            </div>
                            <span
                                v-if="errors[0]"
                                class="invalid-feedback"
                                role="alert"
                            >
                                <strong>{{ errors[0] }}</strong>
                            </span>
                        </ValidationProvider>

                        <button
                            :disabled="disabled"
                            type="submit"
                            class="calculator-button"
                        >
                            შენახვა
                        </button>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useDeclaration } from "../../hooks/declaration";
export default defineComponent({
    props: {
        parcel: {
            type: Object,
            default: null,
        },
        parcelTypes: {
            type: Array,
            default: [],
        },
        country: {
            type: Number,
            default: null,
        },
        currency: {
            type: Object,
            default: null,
        },
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    setup(props, { emit }) {
        const observer = ref(null);
        const disabled = ref(false);
        const price = ref("");
        const type = ref("");

        const { onSaveItem } = useDeclaration();

        const onSave = () => {
            disabled.value = true;

            onSaveItem({
                id: props.parcel.id,
                type_id: type.value,
                price: price.value,
            }).then((e) => {
                disabled.value = true;
                emit("close");
            });
        };

        onMounted(() => {
            $(`.parcelTypes-${props.parcel.id}`)
                .select2({
                    placeholder: "აირჩიე კატეგორია",
                })
                .on("select2:select", (e) => {
                    type.value = e.params.data.id;
                });
        });
        return {
            props,
            emit,
            onSave,
            disabled,
            price,
            type,
            observer,
        };
    },
});
</script>
